<template>
  <b-row>
    <b-col md="5">
      <b-form-group label="Start Date">
        <flat-pickr v-model="data.from.value" class="form-control" />
      </b-form-group>
    </b-col>
    <b-col md="5">
      <b-form-group label="End Date">
        <flat-pickr v-model="data.to.value" class="form-control" />
      </b-form-group>
    </b-col>
    <b-col 
      md="2" 
      class="buttons-wrapper d-flex flex-wrap"
    >
      <b-button 
        @click="emitFilter" 
        class="btn btn-danger me-2"
      >Filter</b-button>

      <b-button 
        @click="emitExport" 
        class="btn btn-danger"
      >Export</b-button>
    </b-col>
  </b-row>
</template>

<script>
import { 
  BLink,
  BImg,
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BProgress,
  BCardText,
  BDropdown,
  BDropdownItem 
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BLink,
    BImg,
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BProgress,
    BCardText,
    BDropdown,
    BDropdownItem,
    flatPickr
  },
  props: {
    date: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      data: {},
    }
  },
  watch: {
    date: {
      handler(newVal) {
        this.data.from = newVal.from
        this.data.to = newVal.to
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    emitFilter() {
      this.$emit('filter-date')
    },
    emitExport() {
      this.$emit('export')
    }
  }
}
</script>

<style>
.buttons-wrapper {
  justify-content: flex-start; 
  gap: 0.5rem;
  align-items: center;
  margin-top: 0.8rem;
}
@media (max-width: 1100px) {
  .buttons-wrapper {
    flex: 0 0 100%; 
    max-width: 100%; 
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
